<template>
  <div>
    <h2>SuccessStoriesSubpage</h2>
  </div>
</template>

<script>
export default {
  name: "SuccessStoriesSubpage",
  data: () => ({
  }),
  computed: {
  },
  methods: {
  },
  components: {
  }
};
</script>

<style>
</style>
